import { useEffect } from "react";

// Navigation keys, not typing: a keystroke in a text field shouldn't reveal
// a row's hover controls.
const NAVIGATION_KEYS = new Set([
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
  "Escape",
]);

/**
 * Marks `html[data-keyboard]` while the user navigates by keyboard and clears
 * it on any pointer press. Chrome also treats focus that a menu hands back
 * after a click as focus-visible, so styles that reveal hover-only controls
 * key off this flag rather than :focus-visible alone.
 */
export const useKeyboardModality = () => {
  useEffect(() => {
    const root = document.documentElement;
    const onKey = (event: KeyboardEvent) => {
      if (NAVIGATION_KEYS.has(event.key)) root.dataset.keyboard = "";
    };
    const onPointer = () => {
      delete root.dataset.keyboard;
    };
    window.addEventListener("keydown", onKey, true);
    window.addEventListener("pointerdown", onPointer, true);
    return () => {
      window.removeEventListener("keydown", onKey, true);
      window.removeEventListener("pointerdown", onPointer, true);
      delete root.dataset.keyboard;
    };
  }, []);
};
